import { takeLatest, put, call, select } from 'redux-saga/effects';
import { CHECK_HASH_SAGA } from "../sagaTypes";
import { loadingAction } from '../actions.js';
import { url } from "../../config";
import growl from "../../lib/growl/growl.js";
import { setAppStartAction, setUserAction } from "../actions";
import { getLocalStorage, setLocalStorage } from "../../helpers/LocalStorage";
import { USER_INITIAL } from "../initialStateConstants";
import { getBookingSagaAction } from "../sagaActions";

const request = data => {
    return fetch(`${ url }/check_hash`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerCheckHash(args) {
    const user_hash = yield getLocalStorage('afw_u');
    const est = yield select(state => state.est);

    yield put(loadingAction(true));
    try {
        let formData = new FormData();
        formData.append('user_hash', user_hash);

        if (est.slug && est.id) {
            formData.append('slug', est.slug);
            formData.append('est', est.id);
        }

        const response = yield call (request, formData);

        if (response.void) {
            setLocalStorage('afw_u', '').then();
            setUserAction(USER_INITIAL);
            yield put(setAppStartAction(true));
        }
        else if (response.success) {
            // Сохраняем данные пользователя
            yield put(setUserAction(response.user));
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loadingAction(false));
        yield put(setAppStartAction(true));
    }
    finally {
        yield put(loadingAction(false));
        yield put(setAppStartAction(true));

        // Запрашиваем расписание
        yield put(getBookingSagaAction());
    }
}

export default function* watcherCheckHash() {
    yield takeLatest(CHECK_HASH_SAGA, workerCheckHash);
}